<template lang="pug">
  #app
    .body
      menu-header(:titulo="'Consulta Pública'" :transparent="menubar")
      main-page(@navBar='emitNavBar' ref="mainPage" :div="div")
        router-view
        main-footer
</template>

<script>
import MainPage from './layouts/MainPage'
import MenuHeader from './layouts/MenuHeader'
import MainFooter from './layouts/MainFooter'
import RouterMixin from '@/utils/mixins/RouterMixin'

window.$ = require('jquery')

export default {
	name: 'App',
	mixins: [RouterMixin],
	components: {
		MenuHeader, MainPage, MainFooter
	},
	data() {

		return {
			div: 'null',
			menubar: false,
			url_adequacao: '',
			url_centralRt: ''

		}

	},
	methods: {
		emitNavBar(flag) {

			this.menubar = flag

		}
	}
}
</script>

<style lang="sass">
  #app
    height: 100vh
    display: flex

    .body
      display: flex
      height: 100%
      width: 100%
      font-family: 'Open Sans', sans-serif
      flex-direction: column

</style>



// WEBPACK FOOTER //
// src/components/App.vue